var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.654,
    height: 15.632,
    viewBox: "0 0 15.654 15.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67880",
    "data-name": "Path 67880",
    d: "M16.262.775,6.207,10.829A4.1,4.1,0,0,0,5,13.744v1.108a.825.825,0,0,0,.825.825H6.932a4.1,4.1,0,0,0,2.915-1.207L19.9,4.415a2.577,2.577,0,0,0,0-3.64,2.634,2.634,0,0,0-3.64,0Zm2.474,2.474L8.681,13.3a2.49,2.49,0,0,1-1.749.724H6.649v-.283A2.49,2.49,0,0,1,7.373,12L17.428,1.941a.947.947,0,0,1,1.308,0,.926.926,0,0,1,0,1.308Z",
    transform: "translate(-5 -0.045)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.73890bb0f198be5fbae23cd08da120c7.svg";
export { ForwardRef as ReactComponent };